<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ Array.isArray(payment_id) && payment_id.length > 1
            ? 'Edit Payment Orders'
            : 'Edit Payment Order #' + payment_id }}
        </p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-grouped">
          <p class="control is-expanded" v-if="!isMultiData">
            <label class="label">Payment Status</label>
            <select name="payment" id="payment" v-model="payment.payment" class="select is-fullwidth" :disabled="payment_status === 1">
              <option value="">None</option>
              <option value="1" v-if="payment_status === 1">Paid</option>
              <option value="2">Sent</option>
              <option value="3">Confirmed Receipt</option>
              <option value="4">Billed</option>
              <option value="5">Negotiation</option>
              <option value="6">Pending</option>
              <option value="7">Legal Pending</option>
            </select>
          </p>
          <p class="control is-expanded" v-if="!isMultiData">
            <label class="label">Deadline</label>
            <datepicker ref="deadline" placeholder="Date" v-show="parseInt(payment_status) !== 1"></datepicker>
            <input :class="{'input': true, 'is-disabled': true}" type="text" name="deadline" id="deadline" disabled :value="deadline" v-show="payment_status === 1">
          </p>
        </div>
        <div class="control is-grouped" v-show="payment_status !== 1">
          <p class="control is-expanded">
            <label class="label">Pre Payment Method</label>
            <select v-model="payment.pre_payment_method" class="select is-fullwidth">
              <option value="0">None</option>
              <option value="1">Credit Card</option>
              <option value="2">Invoice</option>
              <option value="3">Commissioned</option>
              <option value="4">Billed</option>
              <option value="5">Negotiation</option>
              <option value="6">Pending</option>
              <option value="7">Legal Pending</option>
            </select>
          </p>
        </div>
        <div class="control is-grouped" v-if="parseInt(payment.pre_payment_method) === 1">
          <p class="control is-expanded">
            <label class="label">Card Tag (Month)</label>
            <select v-model="payment.card_tag_month" class="select is-fullwidth">
              <option value="0">Choose Month</option>
              <option v-for="(mes, index) in 12" :key="index+1" :value="index+1">
                {{ new Date(0, index).toLocaleString('pt-BR', { month: 'long' }) }}
              </option>
            </select>
          </p>
          <p class="control is-expanded">
            <label class="label">Card Tag (Year)</label>
            <select v-model="payment.card_tag_year" class="select is-fullwidth">
              <option value="0">Choose Year</option>
              <option :value="year - 3">{{ year - 3 }}</option>
              <option :value="year - 2">{{ year - 2 }}</option>
              <option :value="year - 1">{{ year - 1 }}</option>
              <option :value="year">{{ year }}</option>
              <option :value="year + 1">{{ year + 1 }}</option>
          </select>
          </p>
        </div>
        <div class="control is-grouped" v-show="payment_status !== 1">
          <v-select
            :options="parsePaymentMethodSelect(payment_methods)"
            placeholder="Search Payment Method"
            label="name"
            max-height="100px"
            v-model="payment.payment_method"
            v-if="payment_methods"
            style="width: 100%"
          >
          </v-select>
        </div>
        <p class="control is-expanded" v-if="!isMultiData">
          <label class="label">Invoice</label>
          <input type="file" id="invoice" ref="invoice" v-on:change="handleFileUploadInvoice()"/>
        </p>
        <p class="control is-expanded" v-if="!isMultiData">
          <label class="label">Receipt</label>
          <input type="file" id="receipt" ref="receipt" v-on:change="handleFileUploadReceipt()"/>
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || inProgress || error !== '', 'is-loading': inProgress}" @click="save()">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import babelPolyfill from 'babel-polyfill'
  import Datepicker from 'vue-bulma-datepicker'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  export default {
    props: {
      context: {
        type: Object
      },
      payment_id: {
        type: [Number, Array],
        required: true
      },
      deadline: {
        type: String,
        required: true
      },
      payment_status: {
        type: Number,
        required: true
      },
      payment_method: {
        required: true
      },
      pre_payment_method: {
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        isMultiData: false,
        payment: {
          payment_id: 0,
          payment: '',
          deadline: '',
          payment_method: '',
          pre_payment_method: '',
          card_tag_month: 0,
          card_tag_year: 0
        },
        inProgress: false,
        error: '',
        year: new Date().getFullYear(),
        file: null,
        file2: null,
        payment_methods: null
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)

        // Define se está lidando com múltiplas POs
        this.isMultiData = Array.isArray(this.payment_id) && this.payment_id.length > 1

        // Guarda os IDs no formato de array
        this.payment.payment_id = Array.isArray(this.payment_id)
          ? this.payment_id
          : [this.payment_id]

        // Preenche dados apenas se for uma PO única
        if (!this.isMultiData) {
          this.payment.deadline = this.deadline
          this.payment.payment = (this.payment_status === 0) ? '' : this.payment_status

          if (this.payment_method && this.payment_method.id !== null) {
            this.payment.payment_method = this.payment_method
          }

          // Preenche o campo deadline do datepicker
          if (this.$refs.deadline && this.$refs.deadline.datepicker && this.$refs.deadline.datepicker.input) {
            this.$refs.deadline.datepicker.input.value = this.payment.deadline
          }
        }
        this.payment.pre_payment_method = this.pre_payment_method
        this.loadMethods()
      })
    },
    methods: {
      loadMethods () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/payment_methods', {params: { type: 1 }}).then((response) => {
          this.payment_methods = response.body
        }, (response) => {
        })
      },
      parsePaymentMethodSelect (methods) {
        let methodsTmp = methods.map((method) => {
          let methodName = ''
          if (parseInt(method.method_type) === 1) {
            methodName = method.card_number + ' - ' + method.card_flag + ' - CARD'
          } else {
            methodName = method.bank
            if (method.account !== null) {
              methodName = method.account + ' - ' + methodName
            }
            if (method.agency !== null) {
              methodName = method.agency + ' - ' + methodName
            }
            methodName += ' - BANK'
          }
          return {
            name: methodName,
            id: method.id
          }
        })
        return methodsTmp
      },
      handleFileUploadInvoice () {
        let ext = this.$refs.invoice.files[0].type
        if (ext !== 'application/pdf') {
          this.file = null
          this.$refs.invoice.value = ''
          this.error = 'Select a PDF file!'
        } else {
          this.file = this.$refs.invoice.files[0]
          this.error = ''
        }
      },
      handleFileUploadReceipt () {
        let ext = this.$refs.receipt.files[0].type
        if (ext !== 'application/pdf') {
          this.file2 = null
          this.$refs.receipt.value = ''
          this.error = 'Select a PDF file!'
        } else {
          this.file2 = this.$refs.receipt.files[0]
          this.error = ''
        }
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      async submitFileInvoice () {
        if (this.file !== null) {
          let data = new window.FormData()
          data.append('file', this.file)
          data.append('payment_id', this.payment.payment_id)
          this.context.$http.post(this.context.$store.state.config.apiURL + '/payment/files/invoice', data, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
            return true
          }, (response) => {
            return true
          })
        } else {
          return true
        }
      },
      async submitFileReceipt () {
        if (this.file2 !== null) {
          let data = new window.FormData()
          data.append('file', this.file2)
          data.append('payment_id', this.payment.payment_id)
          this.context.$http.post(this.context.$store.state.config.apiURL + '/payment/files/receipt', data, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
            return true
          }, (response) => {
            return true
          })
        } else {
          return true
        }
      },
      async save () {
        this.inProgress = true
        if (window.confirm('Are you sure you want to edit?')) {
          await this.submitFileInvoice()
          await this.submitFileReceipt()

          if (!this.isMultiData && this.$refs.deadline && this.$refs.deadline.datepicker && this.$refs.deadline.datepicker.input) {
            this.payment.deadline = this.$refs.deadline.datepicker.input.value
          }

          this.error = ''

          const payload = { ...this.payment }

          // Normaliza para garantir que sempre envie um array no campo payment_id
          payload.payment_id = Array.isArray(this.payment_id)
            ? this.payment_id
            : [this.payment_id]

          this.context.$http.post(this.context.$store.state.config.apiURL + '/payment/edit', payload).then((response) => {
            this.inProgress = false
            this.close(false, 'ok')
          }, (response) => {
            this.inProgress = false
            this.error = response.body
          })
        } else {
          this.inProgress = false
        }
      }
    },
    components: {
      Datepicker,
      babelPolyfill,
      vSelect
    },
    computed: {
      isMulti () {
        return this.isMultiData
      },
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// EditPayment.vue?7fb56930